export default {
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  directions: {
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# day} other {# days}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`
  },
  locations: {
    distance: "{distance, number, distance} {unit}"
  },
  info_window: {
    opening_hours: {
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  fuels: {
    fuelsave_midgrade_gasoline: "Shell FuelSave 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    premium_diesel: "Shell V-Power Nitro+ Diesel",
    premium_gasoline: "Shell V-Power Nitro+ ",
    super_premium_gasoline: "Shell V-Power Nitro+ Racing"
  }
}
